import React from 'react'
import { testimonials } from '../../constants'
import { quote } from '../../assets'

function Testimoni() {
  return (
    <section id='testimoni' className="background-gradient">
      <div className="container text-center">
        <div className="row mb-5">
          <h2 className='mb-3 text-dark'>Apa Kata Mereka ?</h2>
          <p className='text-dark desc'>Kami berkomitmen untuk memberikan pelayanan terbaik untuk para pelanggan kami.</p>
        </div>
        <div className="d-flex justify-content-center flex-wrap align-items-center" style={{columnGap: "30px", rowGap: "30px"}}>
          {
            testimonials.map((testimoni => {
              return(
                <div 
                  className="card p-3 text-start card-testimoni" 
                  style={{backgroundColor: "#222", height: "21rem", width: "21rem"}}
                  key={testimoni.id} 
                  data-aos="flip-left" 
                  data-aos-duration="1000"
                >
                  <div className="card-body">
                    <img src={quote} alt="testimonial" width="45px" className='mb-3'/>
                    <p className="card-text text-end text-light" style={{fontSize: testimoni.content.length > 200 ? "14px" : "16px"}}>{testimoni.content}</p>
                    <h6 className="card-title text-end color-secondary">{testimoni.name} - {testimoni.city}</h6>
                  </div>
                </div>
              )
            }))
          }
        </div>
      </div>
    </section>
  )
}

export default Testimoni